import axiosClient from "../api/axiosClient";
import { getRequest, putRequest } from "../api/request";

export const getDailyReports = (params) => {
  return getRequest("/reports/daily", params);
};

export const getCustomerStats = (params) => {
  return getRequest("/reports/customer-stats", params);
};

export const getCustomerLedger = (params) => {
  return getRequest("/reports/ledger", params);
};
export const getDailyLedgerReport = (params) => {
  return getRequest("/reports/dailyledger", params);
};

export const updateLedgerTransactions = async (payload) => {
  return putRequest("/transaction", {
    updates: payload,
  });
};

export const getReportFromAPI = async (params, config = {}) => {
  return await axiosClient.get("/reports/export", { params, ...config });
};

export const getRateWorkReport = async (params, config = {}) => {
  return await axiosClient.get("/reports/ratework/export", {
    params,
    ...config,
  });
};
